export const avatar = {
    default: {
        color: 'brandPrimary3',
        backgroundColor: 'brandPrimary4',
    },
    lychee: {
        color: 'brandSecondary7',
        backgroundColor: 'brandSecondary8',
    },
    mint: {
        color: 'brandSecondary10',
        backgroundColor: 'brandSecondary12',
    },
    coconut: {
        color: 'brandSecondary1',
        backgroundColor: 'brandSecondary3',
    },
    cream: {
        color: 'brandPrimary3',
        backgroundColor: 'neutralBgMedium',
    },
};
export const avatarSizes = {
    xs: {
        width: '24px',
        height: '24px',
    },
    s: {
        width: '36px',
        height: '36px',
    },
    m: {
        width: '40px',
        height: '40px',
    },
    l: {
        width: '60px',
        height: '60px',
    },
    xl: {
        width: '104px',
        height: '104px',
    },
};
export const avatarTextVariants = {
    xs: 'Caption',
    s: 'Text',
    m: 'Subhead',
    l: 'TitleMedium',
    xl: 'TitleLarge',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXZhdGFyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RoZW1lL2F2YXRhci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxNQUFNLENBQUMsTUFBTSxNQUFNLEdBQW1CO0lBQ3BDLE9BQU8sRUFBRTtRQUNQLEtBQUssRUFBRSxlQUFlO1FBQ3RCLGVBQWUsRUFBRSxlQUFlO0tBQ2pDO0lBQ0QsTUFBTSxFQUFFO1FBQ04sS0FBSyxFQUFFLGlCQUFpQjtRQUN4QixlQUFlLEVBQUUsaUJBQWlCO0tBQ25DO0lBQ0QsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGtCQUFrQjtRQUN6QixlQUFlLEVBQUUsa0JBQWtCO0tBQ3BDO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsS0FBSyxFQUFFLGlCQUFpQjtRQUN4QixlQUFlLEVBQUUsaUJBQWlCO0tBQ25DO0lBQ0QsS0FBSyxFQUFFO1FBQ0wsS0FBSyxFQUFFLGVBQWU7UUFDdEIsZUFBZSxFQUFFLGlCQUFpQjtLQUNuQztDQUNGLENBQUM7QUFFRixNQUFNLENBQUMsTUFBTSxXQUFXLEdBQWdCO0lBQ3RDLEVBQUUsRUFBRTtRQUNGLEtBQUssRUFBRSxNQUFNO1FBQ2IsTUFBTSxFQUFFLE1BQU07S0FDZjtJQUNELENBQUMsRUFBRTtRQUNELEtBQUssRUFBRSxNQUFNO1FBQ2IsTUFBTSxFQUFFLE1BQU07S0FDZjtJQUNELENBQUMsRUFBRTtRQUNELEtBQUssRUFBRSxNQUFNO1FBQ2IsTUFBTSxFQUFFLE1BQU07S0FDZjtJQUNELENBQUMsRUFBRTtRQUNELEtBQUssRUFBRSxNQUFNO1FBQ2IsTUFBTSxFQUFFLE1BQU07S0FDZjtJQUNELEVBQUUsRUFBRTtRQUNGLEtBQUssRUFBRSxPQUFPO1FBQ2QsTUFBTSxFQUFFLE9BQU87S0FDaEI7Q0FDRixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sa0JBQWtCLEdBQXVCO0lBQ3BELEVBQUUsRUFBRSxTQUFTO0lBQ2IsQ0FBQyxFQUFFLE1BQU07SUFDVCxDQUFDLEVBQUUsU0FBUztJQUNaLENBQUMsRUFBRSxhQUFhO0lBQ2hCLEVBQUUsRUFBRSxZQUFZO0NBQ2pCLENBQUMifQ==